import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import PetSearch from "./sections/PetSearch";
import SpeciesEntry from "./sections/SpeciesEntry";
import Questions from "./sections/Questions";
import Topics from "./sections/Topics";
import Newsletter from "./sections/Newsletter";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <PetSearch />
      <SpeciesEntry />
      <Questions />
      <Topics />
      <Newsletter />
      <Footer />
    </div>;
}